export const trackUmamiEvent = (eventName, eventData = {}) => {
  if (typeof window === "undefined" || !window.umami || !eventName) {
    return;
  }

  if (typeof window.umami.track === "function") {
    window.umami.track(eventName, eventData);
    return;
  }

  if (typeof window.umami === "function") {
    window.umami(eventName, eventData);
  }
};
